// extracted by mini-css-extract-plugin
export default {"shimmer":"_bb9c8d0c","shimmerLoadingBackground":"_6b1e6164"};